"use strict";

var _toConsumableArray = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Adornments = void 0;

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stylitas = require("@creditas/stylitas");

var _AlertTriangle = _interopRequireDefault(require("@creditas/icons/dist/alert/AlertTriangle"));

var _AlertCircle = _interopRequireDefault(require("@creditas/icons/dist/alert/AlertCircle"));

var _Loader = _interopRequireDefault(require("@creditas/icons/dist/file/Loader"));

var _Search = _interopRequireDefault(require("@creditas/icons/dist/action/Search"));

var _Check = _interopRequireDefault(require("@creditas/icons/dist/action/Check"));

var _ChevronDown = _interopRequireDefault(require("@creditas/icons/dist/navigation/ChevronDown"));

var _propTypes = require("prop-types");

var _Adornment = require("./Adornment");

var _input = require("./input.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  adornments: _propTypes.array,
  select: _propTypes.bool,
  multiple: _propTypes.bool,
  success: _propTypes.bool,
  warning: _propTypes.bool,
  error: _propTypes.bool,
  loading: _propTypes.bool,
  search: _propTypes.bool,
  IconSelect: _propTypes.elementType,
  IconSuccess: _propTypes.elementType,
  IconWarning: _propTypes.elementType,
  IconError: _propTypes.elementType,
  IconLoader: _propTypes.elementType,
  IconSearch: _propTypes.elementType
} : {};

var IconChevronDown = function IconChevronDown(props) {
  return (0, _core.jsx)(_ChevronDown["default"], props);
};

var IconActionCheck = function IconActionCheck(props) {
  return (0, _core.jsx)(_Check["default"], (0, _extends2["default"])({
    color: "success"
  }, props));
};

var IconAlertTriangle = function IconAlertTriangle(props) {
  return (0, _core.jsx)(_AlertTriangle["default"], (0, _extends2["default"])({
    color: "warning"
  }, props));
};

var IconAlertCircle = function IconAlertCircle(props) {
  return (0, _core.jsx)(_AlertCircle["default"], (0, _extends2["default"])({
    color: "danger"
  }, props));
};

var IconFileLoader = function IconFileLoader(props) {
  return (0, _core.jsx)(_Loader["default"], props);
};

var IconActionSearch = function IconActionSearch(props) {
  return (0, _core.jsx)(_Search["default"], props);
};

var defaultProps = {
  IconSelect: IconChevronDown,
  IconSuccess: IconActionCheck,
  IconWarning: IconAlertTriangle,
  IconError: IconAlertCircle,
  IconLoader: IconFileLoader,
  IconSearch: IconActionSearch,
  adornments: []
};

var Adornments = function Adornments(_ref) {
  var IconSelect = _ref.IconSelect,
      IconSuccess = _ref.IconSuccess,
      IconWarning = _ref.IconWarning,
      IconError = _ref.IconError,
      IconLoader = _ref.IconLoader,
      IconSearch = _ref.IconSearch,
      adornments = _ref.adornments,
      select = _ref.select,
      multiple = _ref.multiple,
      success = _ref.success,
      warning = _ref.warning,
      error = _ref.error,
      loading = _ref.loading,
      search = _ref.search;
  var newAdornments = [].concat(_toConsumableArray(adornments), [select && !multiple && (0, _core.jsx)(IconSelect, {
    key: "iconSelect",
    css: _input.inputIconComponent
  }), search && (0, _core.jsx)(IconSearch, {
    key: "iconSearch",
    css: _input.inputIconComponent
  }), success && (0, _core.jsx)(IconSuccess, {
    key: "iconSuccess",
    css: _input.inputIconComponent
  }), warning && (0, _core.jsx)(IconWarning, {
    key: "iconWarning",
    css: _input.inputIconComponent
  }), error && (0, _core.jsx)(IconError, {
    key: "iconError",
    css: _input.inputIconComponent
  }), loading && (0, _core.jsx)(IconLoader, {
    key: "iconLoader",
    css:
    /*#__PURE__*/
    (0, _css2["default"])([_input.inputIconComponent, _stylitas.utilities.animation.spin()], process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  })]).filter(Boolean);
  return (0, _core.jsx)(_Adornment.Adornment, {
    position: "end"
  }, newAdornments);
};

exports.Adornments = Adornments;
process.env.NODE_ENV !== "production" ? Adornments.propTypes = propTypes : void 0;
Adornments.defaultProps = defaultProps;